import { render, staticRenderFns } from "./detailsdy2.vue?vue&type=template&id=67a87a21&scoped=true&"
import script from "./detailsdy2.vue?vue&type=script&lang=js&"
export * from "./detailsdy2.vue?vue&type=script&lang=js&"
import style0 from "./detailsdy2.vue?vue&type=style&index=0&id=67a87a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a87a21",
  null
  
)

component.options.__file = "detailsdy2.vue"
export default component.exports